import { useDebateContext } from "contexts/DebateContext";
import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import { useState, useEffect } from "react";
import { TYPO } from "styles/Typo";
import { CommnetComponentsType } from "types/main";

function CommentButton({
  data,
  type,
}: {
  data: CommentItem;
  type: CommnetComponentsType;
}) {
  const { toggleComment, openComments } = useDebateContext();
  const isOpen = openComments.has(data?.comment_id);

  if (type === "comment") return null;
  return (
    <div
      data-test-id="comment-button"
      className={`flex gap-1 items-center p-1  ${
        type === "optionDetail" ? "" : "cursor-pointer"
      } debate-comment-button`}
      onClick={(e: any) => {
        e.stopPropagation();
        if (type === "optionDetail") return;
        toggleComment(data?.comment_id);
      }}
      data-gtm-id={`report-opinion-comment-button`}
    >
      <CommentIcon isActive={isOpen} />
      <span
        className={`${TYPO.TYPO7_RG} text-gray30`}
        data-test-id="comment-button-count"
      >
        {data?.comment_count}
      </span>
    </div>
  );
}

const CommentIcon = ({ isActive }: { isActive: boolean }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.6 18.25L4.53 20.32C4.245 20.605 3.91875 20.6687 3.55125 20.5113C3.18375 20.3538 3 20.0725 3 19.6675V6.55C3 6.055 3.17625 5.63125 3.52875 5.27875C3.88125 4.92625 4.305 4.75 4.8 4.75H19.2C19.695 4.75 20.1187 4.92625 20.4713 5.27875C20.8237 5.63125 21 6.055 21 6.55V16.45C21 16.945 20.8237 17.3687 20.4713 17.7212C20.1187 18.0737 19.695 18.25 19.2 18.25H6.6Z"
        fill={isActive ? "var(--blue40)" : "var(--gray30)"}
      />
    </svg>
  );
};

export default CommentButton;
